import React from 'react';

export default function BackIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12.6005 5.60059L7.05072 11.1504H18.9999V12.8496H7.05072L12.6005 18.3994L11.3993 19.6006L4.39935 12.6006C4.0674 12.2686 4.0674 11.7314 4.39935 11.3994L11.3993 4.39941L12.6005 5.60059Z"
        fill="#4B5563"
      />
    </svg>
  );
}
